/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import CallMadeIcon from '@material-ui/icons/CallMade';
import NoDataError from './NoDataError';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: '#fff',
    padding: '2rem 1rem 1rem 1rem',
    borderRadius: '6px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    margin: '20px auto',
    textAlign: 'center',
    width: '601px',
    height: '646px',
    [theme.breakpoints.down('sm')]: {
      width: '90vw',
    },
    [theme.breakpoints.up('sm')]: {
      width: '79vw !important',
    },
    [theme.breakpoints.up('md')]: {
      width: '39vw !important',
    },
  },
  cardContent: {
    display: 'flex',
    padding: '20px',
    flexDirection: 'column',
    minHeight: '230px',
    [theme.breakpoints.down('sm')]: {
      // height: '230px !important',
    },
  },
  actionButtons: {
    marginTop: '2rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& span': {
      fontFamily: 'Raleway, sans-serif !important',
      fontSize: '14px',
      fontWeight: '700',
      lineHeight: '28px',
      letterSpacing: '1px',
      '& svg': {
        fontSize: '1.1rem',
        marginLeft: '0.2rem'
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '13px',
      },
    }

  },
  shuffleButton: {
    backgroundColor: '#ededed !important',
    color: 'black !important',
    borderColor: 'transparent !important',
    borderRadius: '6px',
    textTransform: 'uppercase',
    height: '52px',
    width: '178.5px !important',
    [theme.breakpoints.down('sm')]: {
      width: '114px',
      height: '42px',
    },
  },
  buyNowButton: {
    marginLeft: '0px',
    // width:'114px',
    textTransform: 'uppercase',
    backgroundColor: '#B3261D !important',
    color: 'white !important ',
    borderColor: 'transparent !important',
    borderRadius: '6px',
    height: '52px',
    width: '178.5px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '13px',
      height: '42px',
      marginLeft: '1rem',
    },
  }
}));

export default function PlayBookCardFlowers({ products, google, cardHeader, cardSubHeader, actionLabels}) {
  const classes = useStyles();

  const shuffle = () => {
    let newIdx = productIdx;
    while (true) {
      newIdx = Math.floor(Math.random() * products?.length);
      if (newIdx !== productIdx) {
        break;
      }
    }
    setProductIdx(newIdx);
  }

  if (!products || products?.length===0) {
    return (<NoDataError />)
  }

  const [productIdx, setProductIdx] = useState(0);
  const { name, image } = products?.[productIdx];

  const imageSrc = `${image?.path}${image?.name}x.jpg?height=200&width=200&sharpen=a0.5,r1,t1&quality=60&auto=webp&optimize={medium}`;

  const minRange = products?.[productIdx]?.skuPriceRange?.retail?.[0]?.value;
  const maxRange = products?.[productIdx]?.skuPriceRange?.retail?.[1]?.value;

  return (
    <div className={classes.cardContainer}>
      {cardHeader && <div className='cardHeader'> {cardHeader} </div>}
      {cardSubHeader && <div className='cardSubHeader'> {cardSubHeader}</div>}
      <div>
        <img src={imageSrc} className='cardImage' alt='valentine day gift' />
      </div>
      <div className={classes.cardContent}>
        <div className='productTitle'>{name}</div>
        <div className='productRange'>{`$${minRange} - $${maxRange}`}</div>
        <div className={classes.actionButtons}>
          <Button className={classes.shuffleButton} onClick={() => { shuffle() }}>
            {actionLabels[0]}<svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.6851 6.67828C15.5268 4.67869 13.3619 3.33337 10.8823 3.33337C8.07094 3.33337 5.66405 5.06283 4.67028 7.51451M14.6505 7.51451H18V4.1696M5.14823 13.3681C6.30651 15.3677 8.47144 16.713 10.951 16.713C13.7624 16.713 16.1693 14.9835 17.1631 12.5319M7.18283 12.5319H3.83333V15.8768" stroke="#333333" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </Button>
          <Button className={classes.buyNowButton} href={`${products?.[productIdx]?.seo?.url}`} target="_blank">
            {actionLabels[1]}<CallMadeIcon />
          </Button>
        </div>
      </div>
    </div>

  );
}
